import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { detect } from "detect-browser";
import { formatRelative } from "date-fns";
import { enGB } from "date-fns/locale";
import ActionsCog from "../shared/general/ActionsCog";
import candidateType from "./types/candidateType";
import {
  Wrapper,
  Column,
  ActionsCogColumn,
  Top,
  Bottom,
  BottomItem,
  Link,
  Divider,
  CVLink,
  ViewCvButton,
  Number,
} from "./styles/candidate-styles";

export const Candidate = ({ candidate, style, onEditClick }) => {
  const isIE = detect().name === "ie";

  const cogActions = [
    {
      name: "Submit to Job",
      id: 1,
      clickAction: () => {
        window.location.href = candidate.submitToJobLink;
      },
    },
    {
      name: "View CV",
      id: 2,
      clickAction: () => {
        window.location.href = candidate.viewCvLink;
      },
    },
    {
      name: "Edit Candidate",
      id: 3,
      clickAction: () => {
        onEditClick(candidate);
      },
    },
  ];

  const currencySymbol = candidate.recruiter.currency.symbol;

  return (
    <Wrapper style={style}>
      <Column isIE={isIE}>
        <Top titleField>
          <Link href={candidate.viewCandidateLink} title="View Candidate">
            {candidate.firstName} {candidate.lastName}
            <ReactTooltip
              place="right"
              type="dark"
              effect="solid"
              aria-haspopup="true"
              id={`${candidate.id}-feedback`}
            />
          </Link>
        </Top>
        <Bottom desktopStack location>
          <BottomItem noMobile>
            {candidate.updatedAt &&
              formatRelative(Date.parse(candidate.updatedAt), new Date(), {
                locale: enGB,
              }).split(" at")[0]}
          </BottomItem>
          <BottomItem noDesktop>
            <strong>{currencySymbol}</strong> {candidate.desiredSalary}
          </BottomItem>
          <Divider>|</Divider>
          <BottomItem>{candidate.location}</BottomItem>
        </Bottom>
      </Column>
      <Column flexSize={2} hideOnTablet isIE={isIE} ieWidth={isIE}>
        <Top />
        <Bottom desktopStack>
          <ReactTooltip
            html
            place="bottom"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id={`${candidate.id}-desired-salary-tooltip`}
          />
          <BottomItem
            left
            data-html
            data-tip="Desired Salary"
            data-for={`${candidate.id}-desired-salary-tooltip`}
          >
            <Number>
              <strong>{currencySymbol}</strong>
              {candidate.desiredSalary}
            </Number>
          </BottomItem>
          <BottomItem />
        </Bottom>
      </Column>
      <Column flexSize={2} capitalize hideOnTablet isIE={isIE} ieWidth={isIE}>
        <Top />
        <Bottom desktopStack>
          <BottomItem>
            {candidate.lastStatus && candidate.lastStatus.replace("_", " ")}
          </BottomItem>
        </Bottom>
      </Column>
      <Column flexSize={1} hideOnTablet isIE={isIE} ieWidth={isIE} center>
        <CVLink href={candidate.viewCvLink} title="View CV">
          <ViewCvButton>View CV</ViewCvButton>
        </CVLink>
      </Column>
      <ActionsCogColumn>
        <ActionsCog actions={cogActions} />
      </ActionsCogColumn>
    </Wrapper>
  );
};

Candidate.propTypes = {
  candidate: candidateType.isRequired,
  style: PropTypes.shape({}).isRequired,
  onEditClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  categoryFilter: state.agencyCandidatesIndex.categoryFilter,
});

export default connect(mapStateToProps, {})(Candidate);
